/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateEncountersMessagesBody,
  CreateMessageErrorResponse,
  CreateMessageResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createEncountersMessages = (
  encounterId: number,
  createEncountersMessagesBody: CreateEncountersMessagesBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (createEncountersMessagesBody.messageText !== undefined) {
    formData.append(`messageText`, createEncountersMessagesBody.messageText);
  }
  if (createEncountersMessagesBody.files !== undefined) {
    createEncountersMessagesBody.files.forEach((value) => formData.append(`files`, value));
  }

  return api<CreateMessageResponse>({
    url: `/api/encounters/${encounterId}/messages`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getCreateEncountersMessagesMutationOptions = <
  TError = CreateMessageErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersMessages>>,
    TError,
    { encounterId: number; data: CreateEncountersMessagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersMessages>>,
  TError,
  { encounterId: number; data: CreateEncountersMessagesBody },
  TContext
> => {
  const mutationKey = ['createEncountersMessages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersMessages>>,
    { encounterId: number; data: CreateEncountersMessagesBody }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersMessages(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersMessagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersMessages>>
>;
export type CreateEncountersMessagesMutationBody = CreateEncountersMessagesBody;
export type CreateEncountersMessagesMutationError = CreateMessageErrorResponse;

export const useCreateEncountersMessages = <
  TError = CreateMessageErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersMessages>>,
      TError,
      { encounterId: number; data: CreateEncountersMessagesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersMessages>>,
  TError,
  { encounterId: number; data: CreateEncountersMessagesBody },
  TContext
> => {
  const mutationOptions = getCreateEncountersMessagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
